import React from 'react'

import { BaseCountByDateAndEntityWidget } from './BaseCountByDateAndEntityWidget'

export const CountByDateAndOrgWidget = () => {
  return (
    <BaseCountByDateAndEntityWidget
      dataSourceKey="responseCountsByDateAndOrg"
      entityIdField="organization_id"
      getEntityName={(dataPoints) => dataPoints[0].organization_name}
      entityColumnLabel="Organization"
      entityTooltipLabel="organizations"
    />
  )
}
